import { createFileRoute } from "@tanstack/react-router";

import { useT } from "../../../app/i18n";
import { nextSearch } from "../../../features/auth/next";
import { SignInForm } from "../../../features/auth/sign-in-form";

export const Route = createFileRoute("/_auth/sign-in/")({
  validateSearch: nextSearch,
  component: SignInPage,
});

function SignInPage() {
  const { t } = useT();
  const { next } = Route.useSearch();
  return (
    <>
      <h1 className="mb-6 text-xl font-semibold">{t("auth:signIn.title")}</h1>
      <SignInForm next={next} />
    </>
  );
}
